import { Request } from "@xt/xtbase";

const { XtAxios } = Request;
const URL = "/uaapi/user/";

export function get_privateUserVipInfo(config?) {
  return XtAxios.get(URL + "private/userVip/info", config);
}
